<template>
  <div class="vch-dsf-app-wrapper" v-if="isStarted">
    <div v-if="isLoading" class="vch-loader__overlay">
      <div class="vch-loader__container">
        <vch-loader></vch-loader>
      </div>
    </div>
    <vch-load-script
      v-if="isLoading || hasLoaded"
      :attributes="{ type: 'module' }"
      :src="dropperSrc"
    >
      <dsf-app v-bind="config"></dsf-app>
    </vch-load-script>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { mixinParseURL } from 'Mixins/parseURL/parseURL';

export default {
  name: 'vch-dsf-app-wrapper',
  mixins: [mixinParseURL],
  props: {
    config: {
      type: Object,
      required: true,
    },
    dropperSrc: {
      type: String,
      default: 'https://dsf-cdn.loreal.io/dropper.js',
    },
  },
  data() {
    return {
      isStarted: false,
      isLoading: false,
      hasLoaded: false,
      serviceBodyClass: 'dsf-app-fullscreen',
      serviceTriggerURLParamKey: 'dsf-app',
    };
  },

  mounted() {
    //vchy-dsf:skindrv2:start
    eventBus.$on(`vchy-dsf:${this.config.application}:start`, this.start);

    /* istanbul ignore next */
    if (this.URLHasKey(this.serviceTriggerURLParamKey)) {
      this.start();
    }
  },

  methods: {
    start() {
      this.isStarted = true;
      if (!this.hasLoaded) {
        this.isLoading = true;
      }
      this.listenToReady();
    },

    listenToReady() {
      const observer = new MutationObserver(() => {
        this.hasLoaded =
          this.hasLoaded ||
          document.body.classList.contains(this.serviceBodyClass);
        if (this.hasLoaded) {
          this.isLoading = false;
          observer.disconnect();
        }
      });

      window.dsfApp = document.createElement('div');
      window.dsfApp.addEventListener('onReady', () => {
        observer.observe(document.body, { attributes: true });
      });
    },
  },
};
</script>

<style lang="scss" src="./dsf-app-wrapper.scss"></style>
